/**
 * Centralized tab configuration for the admin dashboard.
 *
 * Adding a new tab? Two steps:
 *   1. Append an entry to ADMIN_TABS below (id + label + optional counter).
 *   2. Render the body inside AdminDashboardPage's `{tab === "<id>" && ...}`
 *      block (or import a panel component and render it here).
 *
 * Centralizing the tab list eliminates the "added a tab to the strip but
 * forgot to wire the body" class of bugs that grew the dashboard to 2,800
 * lines in the first place.
 */

/**
 * Build the displayed tab list. Counters are derived at render time so we
 * don't have to memoize anything.
 *
 * @param {Object} args
 * @param {Object} args.reviewsData    — { counts: { pending: number } }
 * @param {Object} args.cartsData      — { counts: { pending: number } }
 * @param {Object} args.securityData   — { locked_ips: any[] }
 */
export const buildAdminTabs = ({ reviewsData, cartsData, securityData } = {}) => {
  const pendingReviews = reviewsData?.counts?.pending || 0;
  const pendingCarts = cartsData?.counts?.pending || 0;
  const lockedIps = securityData?.locked_ips?.length || 0;
  return [
    { id: "orders",    label: "Orders" },
    { id: "analytics", label: "Analytics" },
    { id: "products",  label: "Products / PDFs" },
    { id: "reviews",   label: `Reviews${pendingReviews ? ` (${pendingReviews})` : ""}` },
    { id: "carts",     label: `Abandoned Carts${pendingCarts ? ` (${pendingCarts})` : ""}` },
    { id: "system",    label: "System" },
    { id: "security",  label: `Security & Ops${lockedIps ? ` (${lockedIps})` : ""}` },
    { id: "marketing", label: "Marketing" },
    { id: "audit",     label: "Audit Log" },
  ];
};

/** The default starting tab. */
export const DEFAULT_TAB = "orders";
